const Mutations = Object.freeze({
	SET_GRID_VIEW: 'gridsModule/gridsPageDeleted/SET_GRID_VIEW',
	SET_QUICK_FILTER: 'gridsModule/gridsPageDeleted/SET_QUICK_FILTER',
	SET_ADVANCED_FILTER: 'gridsModule/gridsPageDeleted/SET_ADVANCED_FILTER',
	SET_SORTING: 'gridsModule/gridsPageDeleted/SET_SORTING',
	SET_ROWS_PER_PAGE: 'gridsModule/gridsPageDeleted/SET_ROWS_PER_PAGE',
	SET_PAGE: 'gridsModule/gridsPageDeleted/SET_PAGE',
	SET_COLUMNS: 'gridsModule/gridsPageDeleted/SET_COLUMNS',
	SET_LOADING: 'gridsModule/gridsPageDeleted/SET_LOADING',
	SET_GRID_DATA: 'gridsModule/gridsPageDeleted/SET_GRID_DATA',
	SET_IRIS_USER_METADATA:
		'gridsModule/gridsPageDeleted/SET_IRIS_USER_METADATA',
	SET_TOTAL_COUNT: 'gridsModule/gridsPageDeleted/SET_TOTAL_COUNT',
	SET_RECORD: 'gridsModule/gridsPageDeleted/SET_RECORD',
	SET_ENTITY: 'gridsModule/gridsPageDeleted/SET_ENTITY',
	SET_BULK_RESTORE: 'gridsModule/gridsPageDeleted/SET_BULK_RESTORE',
});
export const Actions = Object.freeze({
	CLEAR: 'gridsModule/gridsPageDeleted/CLEAR',
	LOAD_GRID_VIEW: 'gridsModule/gridsPageDeleted/LOAD_GRID_VIEW',
	LOAD_GRID_DATA: 'gridsModule/gridsPageDeleted/LOAD_GRID_DATA',
	LOAD_RECORD: 'gridsModule/gridsPageEdit/LOAD_RECORD',
	RESTORE_DATA: 'gridsModule/gridsPageDeleted/RESTORE_DATA',
	BULK_RESTORE_DATA: 'gridsModule/gridsPageDeleted/BULK_RESTORE_DATA',
	UPDATE_ROWS_PER_PAGE: 'gridsModule/gridsPageDeleted/UPDATE_ROWS_PER_PAGE',
	UPDATE_PAGE: 'gridsModule/gridsPageDeleted/UPDATE_PAGE',
	UPDATE_SORTING: 'gridsModule/gridsPageDeleted/UPDATE_SORTING',
	UPDATE_QUICK_FILTER: 'gridsModule/gridsPageDeleted/UPDATE_QUICK_FILTER',
	UPDATE_ADVANCED_FILTER:
		'gridsModule/gridsPageDeleted/UPDATE_ADVANCED_FILTER',
	EXPORT_CURRENT_GW_PAGE:
		'gridsModule/gridsPageDeleted/EXPORT_CURRENT_GW_PAGE',
	EXPORT_ALL_DATA: 'gridsModule/gridsPageDeleted/EXPORT_ALL_DATA',
});
export const Getters = Object.freeze({
	GRID_VIEW: 'gridsModule/gridsPageDeleted/GRID_VIEW',
	PAGE: 'gridsModule/gridsPageDeleted/PAGE',
	ROWS_PER_PAGE: 'gridsModule/gridsPageDeleted/ROWS_PER_PAGE',
	VISIBLE_COLUMNS: 'gridsModule/gridsPageDeleted/VISIBLE_COLUMNS',
	HIDDEN_COLUMNS: 'gridsModule/gridsPageDeleted/HIDDEN_COLUMNS',
	TOTAL_COUNT: 'gridsModule/gridsPageDeleted/TOTAL_COUNT',
	GRID_DATA: 'gridsModule/gridsPageDeleted/GRID_DATA',
	IRIS_USER_METADATA: 'gridsModule/gridsPageDeleted/IRIS_USER_METADATA',
	GRID_LOADING: 'gridsModule/gridsPageDeleted/GRID_LOADING',
	SORTING: 'gridsModule/gridsPageDeleted/SORTING',
	QUICK_FILTER: 'gridsModule/gridsPageDeleted/QUICK_FILTER',
	ADVANCED_FILTER: 'gridsModule/gridsPageDeleted/ADVANCED_FILTER',
});
import { GeneralActions } from '../../../../actions';
import dataService from '../../../../../services/data/projectGridsService';
import { processEnum } from '../../../../../enums/processEnum';
import exportDataService from '../../../../../services/data/dataExportService';
import fileUtils from '../../../../../utils/fileUtils';
import { ExportMode } from '../../../../../enums/ExportMode';
export default {
	state: {
		gridView: null,
		quickFilter: { FieldId: null, Value: '' },
		advancedFilter: { Operator: 1, Filters: [], FiltersCount: 0 },
		selectedEntity: {},
		sorting: [],
		rowsPerPage: 50,
		page: 1,
		record: {},
		columns: [],
		loading: false,
		gridData: [],
		irisUsersMetadata: [],
		totalCount: 0,
	},
	mutations: {
		[Mutations.SET_GRID_VIEW](state, item) {
			state.gridView = item;
		},
		[Mutations.SET_QUICK_FILTER](state, item) {
			state.quickFilter = item;
		},
		[Mutations.SET_ADVANCED_FILTER](state, item) {
			state.advancedFilter = item;
			state.advancedFilter.FiltersCount = item.Filters.length;
		},
		[Mutations.SET_SORTING](state, item) {
			state.sorting = item;
		},
		[Mutations.SET_ROWS_PER_PAGE](state, value) {
			state.rowsPerPage = value;
		},
		[Mutations.SET_PAGE](state, value) {
			state.page = value;
		},
		[Mutations.SET_COLUMNS](state, items) {
			state.columns = items;
		},
		[Mutations.SET_LOADING](state, value) {
			state.loading = value;
		},
		[Mutations.SET_GRID_DATA](state, items) {
			state.gridData = items;
		},
		[Mutations.SET_IRIS_USER_METADATA](state, items) {
			state.irisUsersMetadata = items;
		},
		[Mutations.SET_TOTAL_COUNT](state, value) {
			state.totalCount = value;
		},
		[Mutations.SET_TOTAL_COUNT_RESTORE](state, value) {
			state.totalCount = value;
		},

		[Mutations.SET_RECORD](state, item) {
			state.record = item;
		},
		[Mutations.SET_ENTITY](state, item) {
			state.selectedEntity = item;
		},
		[Mutations.SET_BULK_RESTORE](state, items) {
			items.forEach((x) => {
				let index = state.gridData.findIndex((asset) => asset.Id === x);
				state.gridData.splice(index, 1);
			});
			state.totalCount -= items.length;
		},
	},
	actions: {
		[Actions.CLEAR]({ commit }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_GRID_VIEW, null);
				commit(Mutations.SET_GRID_DATA, null);
				commit(Mutations.SET_IRIS_USER_METADATA, []);
				commit(Mutations.SET_TOTAL_COUNT, 0);
				commit(Mutations.SET_PAGE, 1);
				commit(Mutations.SET_ROWS_PER_PAGE, 50);
				commit(Mutations.SET_LOADING, false);
				commit(Mutations.SET_SORTING, []);
				commit(Mutations.SET_ADVANCED_FILTER, {
					Operator: 1,
					Filters: [],
					FiltersCount: 0,
				});
				commit(Mutations.SET_QUICK_FILTER, {
					FieldId: null,
					Value: '',
				});
				commit(Mutations.SET_COLUMNS, []);
				commit(Mutations.SET_ENTITY, {});

				resolve();
			});
		},

		[Actions.LOAD_GRID_VIEW]({ commit, dispatch }, item) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				commit(Mutations.SET_GRID_VIEW, item);
				commit(Mutations.SET_ROWS_PER_PAGE, item.RowsPerPage);
				commit(Mutations.SET_PAGE, 1);
				commit(Mutations.SET_SORTING, item.Sorting);
				commit(
					Mutations.SET_QUICK_FILTER,
					item.QuickFilter || { FieldId: null, Value: '' }
				);
				commit(Mutations.SET_ADVANCED_FILTER, {
					Operator: item.AdvancedFilterOperator || 1,
					Filters: item.AdvancedFilter || [],
				});
				commit(Mutations.SET_COLUMNS, item.Columns);
				commit(Mutations.SET_ENTITY, item.Entity);
				dispatch(Actions.LOAD_GRID_DATA);
				dispatch(GeneralActions.LOADING, false);
				resolve();
			});
		},
		[Actions.LOAD_GRID_DATA]({ state, commit, dispatch }) {
			return new Promise((resolve) => {
				commit(Mutations.SET_LOADING, true);
				let payload = {
					IncludeCount: true,
					ViewId: state.gridView.Id,
					RowsPerPage: state.rowsPerPage,
					Page: state.page,
					Columns: state.columns
						.filter((x) => x.IsVisible)
						.map((x) => x.Id),
					IncludeDeleted: true,
				};
				if (state.sorting.length > 0) payload.Sorting = state.sorting;
				if (state.advancedFilter.Filters.length > 0)
					payload.AdvancedFilter = state.advancedFilter;
				if (state.quickFilter.Value)
					payload.QuickFilter = state.quickFilter;
				dataService
					.loadData(payload)
					.then((resp) => {
						commit(Mutations.SET_TOTAL_COUNT, resp.data.Count);
						commit(Mutations.SET_GRID_DATA, resp.data.Data);
						commit(
							Mutations.SET_IRIS_USER_METADATA,
							resp.data.IrisUsers
						);
						commit(Mutations.SET_LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						commit(Mutations.SET_LOADING, false);
						resolve(false);
					});
			});
		},
		[Actions.LOAD_RECORD]({ commit, dispatch, state }, recordId) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				Promise.all([
					dataService
						.getGridRecord(recordId, state.selectedEntity)
						.then((resp) => {
							commit(Mutations.SET_RECORD, resp.data);
						}),
				])
					.then(() => {
						dispatch(GeneralActions.LOADING, false);
						resolve(true);
					})
					.catch((error) => {
						dispatch(GeneralActions.ERROR, error);
						dispatch(GeneralActions.LOADING, false);
					});
			});
		},
		[Actions.RESTORE_DATA]({ state, dispatch, commit }) {
			return new Promise((resolve, reject) => {
				dispatch(GeneralActions.LOADING, true);
				let item = state.record;
				let formData = new FormData();
				let itemModel = {};
				Object.keys(item).forEach((key) => {
					if (key.includes('FileUdf') && item[key]) {
						formData.append(key, item[key]);
					} else {
						itemModel[key] = item[key];
					}
				});

				if (Object.keys(itemModel).length) {
					formData.append('item', JSON.stringify(itemModel));
				}
				if (JSON.stringify(item) == '{}') {
					dispatch(GeneralActions.LOADING, false);
					reject(false);
				} else {
					if (item.Id) {
						dataService
							.putGridAsset(
								formData,
								state.selectedEntity,
								processEnum.EditGrid
							)
							.then(() => {
								commit(Mutations.SET_RECORD, {});
								dispatch(GeneralActions.LOADING, false);
								resolve(true);
							})
							.catch((error) => {
								dispatch(GeneralActions.ERROR, error);
								dispatch(GeneralActions.LOADING, false);
							});
					}
				}
			}).then(() => dispatch(Actions.LOAD_GRID_VIEW, state.gridView));
		},
		[Actions.BULK_RESTORE_DATA]({ dispatch, commit }, payload) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				dataService
					.bulkRestore(payload)
					.then(() => {
						commit(
							Mutations.SET_BULK_RESTORE,
							payload.SelectedRows
						);
						resolve(true);
					})
					.catch((error) => dispatch(GeneralActions.ERROR, error))
					.finally(() => dispatch(GeneralActions.LOADING, false));
			});
		},
		[Actions.UPDATE_PAGE]({ commit, dispatch }, value) {
			commit(Mutations.SET_PAGE, value);
			dispatch(Actions.LOAD_GRID_DATA);
		},
		[Actions.UPDATE_ROWS_PER_PAGE]({ commit, dispatch }, value) {
			commit(Mutations.SET_ROWS_PER_PAGE, value);
			commit(Mutations.SET_PAGE, 1);
			dispatch(Actions.LOAD_GRID_DATA);
		},
		[Actions.UPDATE_SORTING]({ commit, dispatch }, value) {
			commit(Mutations.SET_SORTING, value);
			commit(Mutations.SET_PAGE, 1);
			dispatch(Actions.LOAD_GRID_DATA);
		},
		[Actions.UPDATE_QUICK_FILTER]({ commit, dispatch }, value) {
			commit(Mutations.SET_QUICK_FILTER, value);
			commit(Mutations.SET_PAGE, 1);
			dispatch(Actions.LOAD_GRID_DATA);
		},
		[Actions.UPDATE_ADVANCED_FILTER]({ commit, dispatch }, value) {
			commit(Mutations.SET_ADVANCED_FILTER, value);
			commit(Mutations.SET_PAGE, 1);
			dispatch(Actions.LOAD_GRID_DATA);
		},
		[Actions.EXPORT_CURRENT_GW_PAGE](
			{ dispatch, state },
			{ timeZone = 0, isDirectMode = ExportMode.DIRECT } = {}
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let payload = {
					IncludeCount: true,
					ViewId: state.gridView.Id,
					RowsPerPage: state.rowsPerPage,
					Page: state.page,
					TimeZone: timeZone,
					Columns: state.columns
						.filter((x) => x.IsVisible)
						.sort((a, b) => a.Order - b.Order)
						.map((x) => x.Id),
					IncludeDeleted: true,
				};
				if (state.sorting.length > 0) payload.Sorting = state.sorting;
				if (state.advancedFilter.Filters.length > 0)
					payload.AdvancedFilter = state.advancedFilter;
				if (state.quickFilter.Value)
					payload.QuickFilter = state.quickFilter;
				if (isDirectMode === ExportMode.DIRECT) {
					exportDataService
						.downloadGridViewDirect(payload)
						.then((resp) => {
							const fileInfo =
								fileUtils.extractFileInfoFromResponse(resp);
							const blob = new Blob([resp.data], {
								type: fileInfo.mimeType,
							});
							const url = window.URL.createObjectURL(blob);
							const link = document.createElement('a');
							link.href = url;

							const filename = fileInfo.filename;

							link.setAttribute('download', filename);
							document.body.appendChild(link);
							link.click();

							// Clean up resources
							document.body.removeChild(link);
							window.URL.revokeObjectURL(url);

							resolve(true);
						})
						.catch((error) => {
							dispatch(GeneralActions.ERROR, error);
							resolve(false);
						})
						.finally(() => {
							dispatch(GeneralActions.LOADING, false);
						});
				} else {
					// Background export mode
					exportDataService
						.downloadGridView(payload)
						.then(() => {
							resolve(true);
						})
						.catch((error) => {
							dispatch(GeneralActions.ERROR, error);
							resolve(false);
						})
						.finally(() => {
							dispatch(GeneralActions.LOADING, false);
						});
				}
			});
		},
		[Actions.EXPORT_ALL_DATA](
			{ dispatch, state },
			{ timeZone = 0, isDirectMode = ExportMode.DIRECT } = {}
		) {
			return new Promise((resolve) => {
				dispatch(GeneralActions.LOADING, true);
				let payload = {
					IncludeCount: true,
					ViewId: state.gridView.Id,
					RowsPerPage: state.totalCount,
					Page: 1,
					TimeZone: timeZone,
					Columns: state.columns
						.filter((x) => x.IsVisible)
						.sort((a, b) => a.Order - b.Order)
						.map((x) => x.Id),
					IncludeDeleted: true,
				};
				if (state.sorting.length > 0) payload.Sorting = state.sorting;
				if (state.advancedFilter.Filters.length > 0)
					payload.AdvancedFilter = state.advancedFilter;
				if (state.quickFilter.Value)
					payload.QuickFilter = state.quickFilter;
				if (isDirectMode === ExportMode.DIRECT) {
					exportDataService
						.downloadGridViewDirect(payload)
						.then((resp) => {
							const fileInfo =
								fileUtils.extractFileInfoFromResponse(resp);
							const blob = new Blob([resp.data], {
								type: fileInfo.mimeType,
							});
							const url = window.URL.createObjectURL(blob);
							const link = document.createElement('a');
							link.href = url;

							const filename = fileInfo.filename;

							link.setAttribute('download', filename);
							document.body.appendChild(link);
							link.click();

							// Clean up resources
							document.body.removeChild(link);
							window.URL.revokeObjectURL(url);

							resolve(true);
						})
						.catch((error) => {
							dispatch(GeneralActions.ERROR, error);
							resolve(false);
						})
						.finally(() => {
							dispatch(GeneralActions.LOADING, false);
						});
				} else {
					// Background export mode
					exportDataService
						.downloadGridView(payload)
						.then(() => {
							resolve(true);
						})
						.catch((error) => {
							dispatch(GeneralActions.ERROR, error);
							resolve(false);
						})
						.finally(() => {
							dispatch(GeneralActions.LOADING, false);
						});
				}
			});
		},
	},
	getters: {
		[Getters.GRID_VIEW]: (state) => {
			return state.gridView;
		},
		[Getters.PAGE]: (state) => {
			return state.page;
		},
		[Getters.ROWS_PER_PAGE]: (state) => {
			return state.rowsPerPage;
		},
		[Getters.VISIBLE_COLUMNS]: (state) => {
			if (!state.columns) return [];
			let visibleColumns = state.columns
				.filter((x) => x.IsVisible === true)
				.sort((a, b) => a.Order - b.Order);
			return JSON.parse(JSON.stringify(visibleColumns));
		},
		[Getters.HIDDEN_COLUMNS]: (state) => {
			if (!state.columns) return [];
			let hiddenColumns = state.columns
				.filter((x) => x.IsVisible === false)
				.sort((a, b) => a.Order - b.Order);
			return JSON.parse(JSON.stringify(hiddenColumns));
		},
		[Getters.TOTAL_COUNT]: (state) => {
			return state.totalCount;
		},
		[Getters.GRID_DATA]: (state) => {
			if (!state.gridData) return [];
			return JSON.parse(JSON.stringify(state.gridData));
		},
		[Getters.IRIS_USER_METADATA]: (state) => {
			if (!state.irisUsersMetadata) return [];
			if (state.irisUsersMetadata.length <= 0) return [];
			return JSON.parse(JSON.stringify(state.irisUsersMetadata));
		},
		[Getters.SORTING]: (state) => {
			return JSON.parse(JSON.stringify(state.sorting));
		},
		[Getters.GRID_LOADING]: (state) => {
			return state.loading;
		},
		[Getters.QUICK_FILTER]: (state) => {
			return JSON.parse(JSON.stringify(state.quickFilter));
		},
		[Getters.ADVANCED_FILTER]: (state) => {
			if (!state.advancedFilter) return [];
			return JSON.parse(JSON.stringify(state.advancedFilter));
		},
	},
};
